import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import 'antd/dist/reset.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import AccesoRestringido from './components/AccesoRestringido/AccesoRestringido';


import LogosFooter from './components/LogosHeader/LogosFooter';
import NavBodecom from './components/header/navBodecom';
import LoginBodecom from './components/Login/loginBodecom';
import PrivateRoute from './components/Login/PrivateRoute';
import MapaInicio from './components/mapas/mapaInicio';
import Inicio from './components/Inicio/Inicio';
import AppSlider from './components/appSlider/AppSlider';
import ForceLogoutModal from './components/Login/ForceLogoutModal';
import AdminPanel from './pages/AdminPanel';
import RepositorioUrl from './components/Inicio/Repositorio/RepositorioUrl';
import Riesgos from './components/Riesgos/Riesgos';
import Bodegas from './components/Bodega/Bodegas';
import Participante from './components/Participante/Participantes/ParticipantesPage';
import DashboardParticipante from './components/Participante/Dashboard/DashboardPage';
import PoaPlanOperativo from './components/poaReporte/PoaPlanOperativo';
import ParticipantesActa from './components/Actas/ParticipantesActas';
import ReporteRit from './components/ReporteRit/ReporteRit';


const AppContent = () => {
  const location = useLocation();
  const showNavAndFooter = !['/', '/acceso-restringido'].includes(location.pathname);

  return (
    <>
      {showNavAndFooter && <NavBodecom />}
      <ForceLogoutModal />
      <Routes>
        <Route path="/" element={<LoginBodecom />} />
        <Route path="/mapas" element={<PrivateRoute element={<MapaInicio />} />} />
        <Route path="/inicio/:slug?" element={<PrivateRoute element={<Inicio />} />} />
        <Route path="/riesgos" element={<PrivateRoute element={<Riesgos />} />} />
        <Route path="/bodegas" element={<PrivateRoute element={<Bodegas />} />} />
        <Route path="/actas" element={<PrivateRoute element={<ParticipantesActa />} />} />
        <Route path="/dashboardparticipante" element={<PrivateRoute element={<DashboardParticipante />} />} />
        <Route path="/participante" element={<PrivateRoute element={<Participante />} />} />
        <Route path="/reporteRIT" element={<PrivateRoute element={<ReporteRit />} />} />


        {/*POA Proyecto */}
        <Route path="/planOperativo" element={<PrivateRoute element={<PoaPlanOperativo />} />} />
        <Route path="/planOperativo/:id?/:tarea?/:infraestructura?" element={<PrivateRoute element={<PoaPlanOperativo />} />} />


        <Route path="/Documentos724" element={<Navigate to="/acceso-restringido" />} />
        <Route path="/DocumentosActualizacion" element={<Navigate to="/acceso-restringido" />} />
        <Route path="/DocumentosOrganizaciones" element={<Navigate to="/acceso-restringido" />} />
        <Route path="/app-slider" element={<PrivateRoute element={<AppSlider />} />} />
        <Route path="/acceso-restringido" element={<AccesoRestringido />} />
        <Route path="/comunix" element={<PrivateRoute element={<AdminPanel />} />} />
        <Route path="/repositorio-documental/:proyecto" element={<PrivateRoute element={<RepositorioUrl />} />} />
        <Route path="*" element={<Navigate to="/acceso-restringido" />} />
      </Routes>
      {showNavAndFooter && <LogosFooter />}
    </>
  );
};

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
